import React, { useState, useEffect } from 'react';
import { useLocation, Link, Navigate } from 'react-router-dom';
import { api } from '../api/client';

const VerifyEmail: React.FC = () => {
  const [message, setMessage] = useState('');
  const [verifyingToken, setVerifyingToken] = useState(false);
  const [verified, setVerified] = useState(false);
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const token = params.get('token');

  useEffect(() => {
    if (token) {
      setVerifyingToken(true);
      api.get(`/auth/verify-email?token=${token}`)
        .then(() => {
          setVerified(true);
          setMessage('Email verified successfully! You can now log in.');
        })
        .catch((err: any) => {
          setMessage(err.response?.data?.message || 'Verification failed. Link might be expired.');
        })
        .finally(() => setVerifyingToken(false));
    }
  }, [token]);

  if (!token) {
    return <Navigate to="/account" replace />;
  }

  if (verified) {
    return (
      <div className="container mt-5" role="main">
        <h2>Email Verified</h2>
        <p className="alert alert-success">{message}</p>
        <Link to="/login" className="btn btn-primary">Go to Login</Link>
      </div>
    );
  }

  if (verifyingToken) {
    return (
      <div className="container mt-5" role="main">
        <h2>Verifying...</h2>
        <p>Please wait while we verify your email.</p>
      </div>
    );
  }

  return (
    <div className="container mt-5" role="main">
      <h2>Verification</h2>
      {message && <p className="alert alert-danger">{message}</p>}
      <p>If the link is expired, please go to your account settings to request a new one.</p>
      <Link to="/account" className="btn btn-primary">Go to Account</Link>
    </div>
  );
};

export default VerifyEmail;
